import { useEffect, FC } from 'react';
import { useAppDispatch, useAppSelector } from 'store/store';
import { GetIntroTour } from '../../../store/IntroTour/introductionTourThunk';
import { useApplicationContext } from 'components/hooks/UseApplicationContext';
import { setupIntroductionTour } from 'services/IntroTour/introTourService';

export const IntroductionTour: FC = () => {
    const dispatch = useAppDispatch();
    const { hasOnlyB2b2cAccess } = useApplicationContext();
    const { introTour, isLoading } = useAppSelector(state => state.introTour);

    const hasIntroTour = !hasOnlyB2b2cAccess;

    useEffect(() => {
        if (hasIntroTour) {
            dispatch(GetIntroTour());
        }
    }, [dispatch, hasIntroTour]);

    useEffect(() => {
        if (!isLoading && introTour && hasIntroTour) {
            setupIntroductionTour(introTour);
        }
    }, [introTour, isLoading, hasIntroTour]);

    return null;
};